import { IMaskInput } from 'react-imask'
import { cn } from "@/lib/class-control"
import { ControllerRenderProps, FieldValues } from "react-hook-form"

interface InputDateInlineProps<T extends FieldValues> {
  field: ControllerRenderProps<T>
  placeholder?: string
  className?: string
}

export default function InputDateInline<T extends FieldValues>({
  field,
  placeholder = "Digite a data",
  className,
  ...props
}: InputDateInlineProps<T>) {

  const formatDate = (date: any): string => {
    if (!date) return ""
    if (typeof date === "string") {
      if (date.includes("/")) return date
      const apiDate = new Date(date)
      if (!isNaN(apiDate.getTime())) return apiDate.toLocaleDateString("pt-BR")
      return date
    }
    if (date instanceof Date && !isNaN(date.getTime())) {
      return date.toLocaleDateString("pt-BR")
    }
    return String(date)
  }

  return (
    <div className="flex items-center w-full px-3 py-2 border border-gray-600 rounded bg-[#15203c] text-white focus-within:ring-2 focus-within:ring-green-400">
      <IMaskInput
        mask="00/00/0000"
        name={field.name}
        inputRef={field.ref}
        value={formatDate(field.value)}
        onAccept={(value) => field.onChange(value)}
        placeholder={placeholder}
        className={cn(
          "flex-1 bg-transparent outline-none text-sm text-white placeholder-gray-400",
          "autofill:bg-transparent autofill:shadow-[0_0_0_1000px_#15203c_inset] autofill:[-webkit-text-fill-color:#fff]",
          "[&:-webkit-autofill]:bg-transparent [&:-webkit-autofill]:shadow-[0_0_0_1000px_#15203c_inset] [&:-webkit-autofill]:[-webkit-text-fill-color:#fff]",
          "[&:-webkit-autofill:hover]:shadow-[0_0_0_1000px_#15203c_inset] [&:-webkit-autofill:focus]:shadow-[0_0_0_1000px_#15203c_inset]",
          className
        )}
        {...props}
      />
    </div>
  )
}

InputDateInline.displayName = "InputDateInline"